<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('school.payment.setup.feeSetup.copyFee') }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12 form-group">
            <label class="col-form-label">
              {{ $t('school.payment.setup.feeSetup.fromBranch') }}
              <span class="validate">*</span>
              <i class="fa fa-spinner spin" v-if="branch_fetch"></i>
            </label>
            <select
              v-model="model.copy_from_branch_id"
              class="form-control"
              :class="{ 'is-invalid': errors.has('copy_from_branch_id') }"
            >
              <option value>{{ $t('select') }}</option>
              <option
                v-for="(branch, index) in branchList"
                :key="index"
                :value="branch.branch_id"
                >{{ branch.branch_name_en }}</option
              >
            </select>
            <div
              class="invalid-feedback"
              v-if="errors.has('copy_from_branch_id')"
            >
              {{ errors.first('copy_from_branch_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <label class="col-form-label">
              {{ $t('school.payment.setup.feeSetup.mainProgram') }}
              <i
                class="fas fa-question-circle"
                v-tooltip="
                  $t(
                    'school.payment.setup.feeSetup.chooseMainProgramToFilterSubProgram'
                  )
                "
              ></i>
              <i class="fa fa-spinner spin" v-if="main_fetch"></i>
            </label>
            <select
              class="form-control"
              v-model="model.acp_id"
              @change="fetchSubProgram"
            >
              <option value>{{ $t('select') }}</option>
              <option
                v-for="(main, index) in mainPrograms"
                :key="index"
                :value="main.acp_id"
                >{{ main.acp_name_foreign }}</option
              >
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <label class="col-form-label required">
              {{ $t('school.payment.setup.fee_type.fee_type') }}
            </label>
            <select class="form-control" v-model="model.fee_type_id">
              <option value>{{ $t('select') }}</option>
              <option
                v-for="(feeType, index) in feeTypes"
                :key="index"
                :value="feeType.value"
              >
                {{ feeType.text }}
              </option>
            </select>
            <div class="validate" v-if="errors.has('fee_type_id')">
              {{ errors.first('fee_type_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 form-group">
            <form>
              <fieldset>
                <legend>
                  {{ $t('school.payment.setup.feeSetup.subProgram') }}
                </legend>
                <div v-if="sub_fetch" class="text-center">
                  <i class="fa fa-spinner spin"></i>
                </div>
                <div v-else>
                  <div
                    class="row col-md-12 form-group"
                    v-if="subPrograms.length > 0"
                  >
                    <ts-checkbox
                      v-model="allCheck"
                      @change="checkAllSub"
                      :checked="checked"
                    >
                      {{ $t('selectAll') }}
                    </ts-checkbox>
                  </div>
                  <div id="sub-list-container">
                    <div
                      class="row col-md-12 form-group"
                      v-for="(sub, index) in subPrograms"
                      :key="index"
                    >
                      <ts-checkbox
                        v-model="model.acps_id_list"
                        :value="sub.acps_id"
                        >{{ sub.acps_name_foreign }}</ts-checkbox
                      >
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
            <div class="validate" v-if="errors.has('acps_id_list')">
              {{ errors.first('acps_id_list') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click="$emit('close')">{{ $t('cancel') }}</ts-button>
            <ts-button
              @click="copy"
              class="ml-2"
              color="primary"
              :waiting="waiting"
              >{{ $t('copy') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'copyFee',
  data() {
    return {
      model: {
        copy_from_branch_id: '',
        acps_id_list: [],
        acp_id: '',
        fee_type_id: ''
      },
      allCheck: false,
      subPrograms: [],
      branch_fetch: true,
      main_fetch: true,
      sub_fetch: false,
      waiting: false,
      errors: new Errors()
    }
  },
  created() {
    this.$store.commit('feeSetup/SET_BRANCH', [])
    this.getBranch({
      filter: {
        exclude_current: 1 // 1 = true
      }
    }).finally(() => {
      this.branch_fetch = false
    })
    this.getMainProgram().finally(() => {
      this.main_fetch = false
    })
  },
  computed: {
    ...mapState('feeSetup', ['branchList', 'mainPrograms', 'feeTypes']),
    checked() {
      return (this.allCheck =
        this.subPrograms.length == this.model.acps_id_list.length)
    }
  },
  methods: {
    ...mapActions('feeSetup', ['getBranch', 'getMainProgram', 'fetch']),
    fetchSubProgram() {
      if (this.model.acp_id) {
        this.sub_fetch = true
        this.$store
          .dispatch('feeSetup/getSubProgram', this.model.acp_id)
          .then(response => {
            this.subPrograms = response.data
          })
          .finally(() => {
            this.sub_fetch = false
          })
      } else {
        this.subPrograms = []
      }
    },
    checkAllSub(value) {
      if (value) {
        this.model.acps_id_list = []
        this.subPrograms.map(el => {
          this.model.acps_id_list.push(el.acps_id)
        })
      } else {
        this.model.acps_id_list = []
      }
    },
    copy() {
      this.waiting = true
      this.$store
        .dispatch('feeSetup/copyFee', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetch()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
<style scoped>
#sub-list-container {
  max-height: 30vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}</style
>>
